import { createSlice } from '@reduxjs/toolkit';

import { initialState } from './bellNotifications.state';
import {
  bellNotificationActionsReducers,
  listNotificationActionsReducers,
} from './actions';

const bellNotifications = createSlice({
  name: 'bellNotifications',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    bellNotificationActionsReducers(builder);
    listNotificationActionsReducers(builder);
  },
});

export const bellNotificationsReducer = bellNotifications.reducer;
